import React, { useState, useEffect } from "react";
import axios from "axios";

const CourierManagement = () => {
  const [couriers, setCouriers] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    startValue: "",
    orderValue: "",
    accountNo: "",
    domain: "",
    id: null,
  });
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const fetchCouriers = async () => {
    try {
      const response = await axios.get("https://astrovidhya.in/api/couriers");
      setCouriers(response.data);
    } catch (err) {
      console.error("Error fetching couriers:", err);
      setError("Failed to fetch courier details. Please try again.");
    }
  };

  useEffect(() => {
    fetchCouriers();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const method = formData.id ? "put" : "post";
    const url = formData.id
      ? `https://astrovidhya.in/api/couriers/${formData.id}`
      : "https://astrovidhya.in/api/couriers";

    try {
      const response = await axios[method](url, formData);
      if (method === "post") {
        setCouriers([...couriers, response.data]);
      } else {
        setCouriers(
          couriers.map((courier) =>
            courier._id === response.data._id ? response.data : courier
          )
        );
      }
      setSuccessMessage("Courier saved successfully!");
      setFormData({
        name: "",
        startValue: "",
        orderValue: "",
        accountNo: "",
        domain: "",
        id: null,
      });
    } catch (err) {
      console.error("Error saving courier:", err);
      setError("Failed to save courier. Please try again.");
    }
  };

  const handleEdit = (courier) => {
    setFormData({
      name: courier.name,
      startValue: courier.startValue || "",
      orderValue: courier.orderValue || "",
      accountNo: courier.accountNo || "",
      domain: courier.domain || "",
      id: courier._id,
    });
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this courier?")) {
      try {
        await axios.delete(`https://astrovidhya.in/api/couriers/${id}`);
        setCouriers(couriers.filter((courier) => courier._id !== id));
        setSuccessMessage("Courier deleted successfully!");
      } catch (err) {
        console.error("Error deleting courier:", err);
        setError("Failed to delete courier. Please try again.");
      }
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-[90vh] flex items-start">
    {/* Form Section */}
    <div className="w-1/3 bg-white min-h-[80vh] shadow-lg rounded-lg p-4">
      <h2 className="text-2xl font-bold mb-4 text-gray-800">Courier Form</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-gray-700 font-medium mb-1">Courier Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full border rounded-md p-2 focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>
        <div>
  <label className="block text-gray-700 font-medium mb-1">Start Value</label>
  <input
    type="text"
    name="startValue"
    value={formData.startValue}
    onChange={handleChange} // 🔹 Uses same handler as "Courier Name"
    className="w-full border rounded-md p-2 focus:ring-2 focus:ring-blue-500"
    required
  />
</div>


        <div>
          <label className="block text-gray-700 font-medium mb-1">Order Value</label>
          <input
            type="number"
            name="orderValue"
            value={formData.orderValue}
            onChange={handleChange}
            className="w-full border rounded-md p-2 focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium mb-1">Account No.</label>
          <input
            type="text"
            name="accountNo"
            value={formData.accountNo}
            onChange={handleChange}
            className="w-full border rounded-md p-2 focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium mb-1">Domain</label>
          <input
            type="text"
            name="domain"
            value={formData.domain}
            onChange={handleChange}
            className="w-full border rounded-md p-2 focus:ring-2 focus:ring-blue-500"
          />
        </div>
        {error && <p className="text-red-500">{error}</p>}
        {successMessage && <p className="text-green-500">{successMessage}</p>}
        <button
          type="submit"
          className="bg-[#03C9D7] hover:bg-[#02A5B3] text-white font-semibold py-2 px-6 rounded shadow-md transition duration-300 w-1/3"
        >
          Save Courier
        </button>
      </form>
    </div>
  
  

      {/* Courier List */}
      <div className="w-2/3 bg-white min-h-[80vh] shadow-lg rounded-lg p-4 ml-6">
        <h3 className="text-xl font-bold mb-4 text-gray-800">Courier List</h3>
        <table className="min-w-full border-collapse bg-white shadow-md rounded-lg overflow-hidden">
          <thead className="bg-gray-200">
            <tr>
              <th className="px-4 py-2 text-left font-medium text-gray-700">Courier Name</th>
              <th className="px-4 py-2 text-left font-medium text-gray-700">Start Value</th>
              <th className="px-4 py-2 text-left font-medium text-gray-700">Order Value</th>
              <th className="px-4 py-2 text-left font-medium text-gray-700">Account No.</th>
              <th className="px-4 py-2 text-left font-medium text-gray-700">Domain</th>
              <th className="px-4 py-2 text-left font-medium text-gray-700">Actions</th>
            </tr>
          </thead>
          <tbody>
            {couriers.map((courier) => (
              <tr key={courier._id} className="border-t border-gray-300">
                <td className="px-4 py-2">{courier.name}</td>
                <td className="px-4 py-2">{courier.startValue || "N/A"}</td>
                <td className="px-4 py-2">{courier.orderValue || "N/A"}</td>
                <td className="px-4 py-2">{courier.accountNo || "N/A"}</td>
                <td className="px-4 py-2">{courier.domain || "N/A"}</td>
                <td className="px-4 py-2">
                  <button
                    className="bg-yellow-500 text-white px-4 py-2 rounded-md hover:bg-yellow-600"
                    onClick={() => handleEdit(courier)}
                  >
                    Edit
                  </button>
                  <button
                    className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 ml-2"
                    onClick={() => handleDelete(courier._id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {couriers.length === 0 && (
          <p className="text-gray-500 text-center mt-4">No couriers found.</p>
        )}
      </div>
    </div>
  );
};

export default CourierManagement;
